import { InputAdornment } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { formatPercent } from 'shared/utility';
import { FormTextField, FormTextFieldProps } from './FormTextField';

type FormNumberFieldProps<T> = Omit<FormTextFieldProps<T>, 'gridColumn'> & {
    type?: 'money' | 'percent' | 'days' | 'number';
};

export function FormNumberField<T>({ label, name, control, rules, fieldError, type }: FormNumberFieldProps<T>) {
    const value = useWatch({ name, control });

    return (
        <FormTextField
            name={name}
            label={label}
            control={control}
            rules={rules}
            componentProps={{
                type: 'number',
                startAdornment: type === 'money' ? <InputAdornment position='start'>$</InputAdornment> : undefined,
                endAdornment:
                    type === 'percent' && !!value ? (
                        <InputAdornment position={'end'}>
                            {limitLength(formatPercent(Number(value)), 20)}
                        </InputAdornment>
                    ) : type === 'days' ? (
                        <InputAdornment position='end'>Days</InputAdornment>
                    ) : undefined,
            }}
            required={!!rules?.required}
            fieldError={fieldError}
        />
    );
}

const limitLength = (value: string, maxLength: number) => {
    if (value.length > maxLength) {
        return value.substring(0, maxLength - 2) + '...';
    }
    return value;
};
